import { render, staticRenderFns } from "./firstSupplierList.vue?vue&type=template&id=1fc3cd97&scoped=true"
import script from "./firstSupplierList.vue?vue&type=script&lang=js"
export * from "./firstSupplierList.vue?vue&type=script&lang=js"
import style0 from "./firstSupplierList.vue?vue&type=style&index=0&id=1fc3cd97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3cd97",
  null
  
)

export default component.exports